import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Motion, spring } from 'react-motion';
import cx from 'classnames';
import _ from 'lodash';

const propTypes = {
  getActiveDomNode: PropTypes.func.isRequired,
  getContainingDomWidth: PropTypes.func.isRequired,
  getLeftRight: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  recalcDuration: PropTypes.number,
  indicatorClassname: PropTypes.string,
  style: PropTypes.object,
};

const defaultProps = {
  recalcDuration: 0,
  indicatorClassname: '',
  style: {},
};

const initalPosition = {
  left: 0,
  right: 0,
};

export default class IndicatorWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...initalPosition,
      boundingDim: 0,
    };

    this.springParameters = {
      stiffness: 210,
      damping: 26,
    };

    this.preventAnimation = true;
  }

  componentDidMount() {
    /* eslint-disable react/no-did-mount-set-state */
    this.setState(this.getUpdatedState(true));
    /* eslint-enable react/no-did-mount-set-state */

    window.addEventListener('resize', this.resizeCallback);
    window.addEventListener('popstate', this.reEvaluateIndicator);
  }

  UNSAFE_componentWillReceiveProps() {
    const { recalcDuration } = this.props;
    if (recalcDuration) {
      this.count = 0;
      const refresh = () => {
        requestAnimationFrame(() => {
          this.setState(this.getUpdatedState(false));
          if (this.count < Math.ceil(recalcDuration/16)) {
            this.count += 1;
            refresh();
          }
        });
      };
      refresh();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    window.removeEventListener('popstate', this.reEvaluateIndicator);
  }

  getUpdatedState = (domNode, resizeEvent) => {
    const {
      getActiveDomNode,
      getLeftRight,
      getContainingDomWidth,
      location,
    } = this.props;

    // domNode is optional argument, if not passed in will use getAciveDomNode
    if (typeof domNode === 'boolean') {
      resizeEvent = domNode; // eslint-disable-line
      domNode = getActiveDomNode(location); // eslint-disable-line
    }

    const newState = domNode ? getLeftRight(domNode) : initalPosition;
    // if it is a resize event, we need to update the dimensions of the tabs
    if (resizeEvent) {
      return {
        boundingDim: getContainingDomWidth(),
        ...newState,
      };
    }
    return newState;
  };

  // should this be debounced more?
  resizeCallback = _.debounce(() => {
    requestAnimationFrame(() => {
      // this prevents animation of the mobile/desktop layout
      this.preventAnimation = true;
      this.setState(this.getUpdatedState(true));
    });
  }, 16);

  reEvaluateIndicator = () => {
    this.setState(this.getUpdatedState(false));
  };

  handleDomNodeChange = (domNode) => {
    const newValues = this.getUpdatedState(domNode, false);
    if (newValues.left < this.state.left) {
      this.setState({ left: newValues.left });
      setTimeout(() => {
        this.setState({ right: newValues.right });
      }, 60);
    } else {
      this.setState({ right: newValues.right });
      setTimeout(() => {
        this.setState({ left: newValues.left });
      }, 60);
    }
  };

  render() {
    return (
      <div
        style={{ ...this.props.style }}>
        {this.props.children(this.handleDomNodeChange)}
        <Motion
          style={{
            left: this.preventAnimation ?
              this.state.left :
              spring(this.state.left, this.springParameters),
            right: this.preventAnimation ?
              this.state.right :
              spring(this.state.right, this.springParameters),
          }}
          onRest={() => {
            this.preventAnimation = false;
          }}>
          {({ left, right }) => (
            <div
              className={cx('indicator', this.props.indicatorClassname)}
              style={{
                left,
                right: this.state.boundingDim - right,
              }} />
          )}
        </Motion>
      </div>
    );
  }
}

IndicatorWrapper.propTypes = propTypes;
IndicatorWrapper.defaultProps = defaultProps;
